import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Dias from './components/Dias';
import Rutinas from './components/Rutinas';

export default new Router({
    mode: 'history',
    fallback: false,
    scrollBehavior: (to, from, savedPosition) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve({ x: 0, y: 0 })
            }, 500)
        })
    },
    routes: [
        { path: '/', name: 'rutinas', component: Rutinas },
        { path: '/rutinas', name: 'rutinas', component: Rutinas },
    ]

});
